import * as React from 'react';
var ModalMenuContext = /*#__PURE__*/React.createContext({
  modalOpened: false
});
if (process.env.NODE_ENV !== 'production') {
  ModalMenuContext.displayName = 'ModalMenuContext';
}
export default ModalMenuContext;